import { BASEMENT_ATTIC_TYPE_OPTIONS } from '@aloft/toolkit-shared';
import { SimpleSelect } from '@aloft/toolkit-sui';

import type { UseFormRegister } from 'react-hook-form';

import type { ObjectiveCharacteristicsFormInput } from '../schObjectiveCharacteristics.ts';

export const BasementAtticTypeSelect = ({
  register,
  name,
  onChange,
}: {
  register: UseFormRegister<ObjectiveCharacteristicsFormInput>;
  name: 'basement.type' | 'attic.type';
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}) => {
  const { onChange: registerOnChange, ...rest } = register(name);

  return (
    <SimpleSelect
      {...rest}
      onChange={(event) => {
        registerOnChange(event);
        onChange?.(event);
      }}
      label="Type"
      size="sm"
      required
    >
      {BASEMENT_ATTIC_TYPE_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </SimpleSelect>
  );
};
